import React from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import AlbumRow from './album-row';

@inject('albumsStore')
@observer
class AlbumList extends React.Component {
	render () {
		const {albumsStore} = this.props;
		
		console.log(albumsStore.items);
		console.log('[albumsStore.albums]', albumsStore.albums.length);
		
		return (
			<div className="grid-x grid-margin-x albums-grid">
				{
					albumsStore.items.filter(a=>a.id !== null).map(
						(album) => ( <AlbumRow key={ album.id || Date.now() + Math.random() * 5894 } album={ album } />)
					)
				}
			</div>
		);
	}
}

export default AlbumList;
